<!--
 * @Author: your name
 * @Date: 2021-05-20 11:07:43
 * @LastEditTime: 2021-06-03 17:50:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \VtpWechatUI\src\components\HelloWorld.vue
-->
<template>
  <div>
    <div class="weui-flex bannercontainner">
      <div class="weui-flex__item banner" :style="{'height':bannerHeight}"></div>
    </div>
    <div class="weui-flex gonggaocontainer">
      <div class="weui-flex__item gonggao" style="text-align: center;color:white">公告
      </div>
      <div class="weui-flex__item gonggaocontent" @click="tanchu()">
        <label>{{this.gonggao}}</label>
        <label v-if="ellipsisShow">...</label>
      </div>
    </div>
    <div class="js_dialog" id="iosDialog2" style="display: none;" v-show="dialogControl">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__hd">
          <p class="weui-dialog__title">公告</p>
        </div>
        <div class="weui-dialog__bd" style="text-align:left">{{this.gonggaocontent}}</div>
        <div class="weui-dialog__ft">
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" @click="zhixi()">知道了</a>
        </div>
      </div>
    </div>
    <div class="weui-flex linecontainer">
      <div class="weui-flex__item line"></div>
    </div>
    <div class="weui-flex allfunction">
      <div class="weui-flex__item enterParkApplycontainer">
        <div class="weui-flex__item enterParkApplyleftcontent" @click="jumpEdit()" :style="{'height':functionHeightLeft}">
          <div class="enterParkApplyleftcontentDiv1">
            入园申请
          </div>
          <div class="enterParkApplyleftcontentDiv2">提前登记，出入无忧</div>
        </div>
      </div>
      <div class="weui-flex__item enterParkApplyrightcontainer">
        <div class="weui-flex__item enterParkApplyrightcontent1" @click="jumpApplicationRecord()" :style="{'height':functionHeightRight}">
          <div class="enterParkApplyrightcontent">申请记录</div>
          <div class="enterParkApplyrightcontentTwo">提前登记，出入无忧</div>
        </div>
        <div class="weui-flex__item enterParkApplyrightcontent2" @click="jumpCancleVisit()" :style="{'height':functionHeightRight,'margin-top':'5px'}">
          <div class="enterParkApplyrightcontent">取消来访</div>
          <div class="enterParkApplyrightcontentTwo">提前登记，出入无忧</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction } from '../request/http'

export default {
  name: 'HelloWorld',
  data() {
    return {
      ellipsisShow: false,
      dialogControl: false,
      gonggao: '',
      gonggaocontent: '',
      screenWidth: document.body.clientWidth, // 屏幕宽
      datalist: [],
      pageInfo: {
        currentPage: 1, // 当前页面
        pageSize: 10,
        totalCount: 0, // 总数
        sord: 'desc',
        sidx: 'id'
      }
    }
  },
  computed: {
    // 滚动区高度
    // (业务需求：手机屏幕高度减去头部标题和底部tabbar的高度，当然这2个高度也是可以动态获取的)
    bannerHeight() {
      return this.screenWidth / 2.8 + 'px'
    },
    functionHeightLeft() {
      return this.screenWidth / 1.8 + 'px'
    },
    functionHeightRight() {
      return this.screenWidth / 3.7 + 'px'
    }
  },
  created() {
  },
  mounted() {
    this.indexnotice()
    // getAction("/vtp/toaEnterParkApply/list", this.pageInfo).then((res) => {
    //   this.datalist = res.data.result.dataList
    // })
  },
  methods: {
    zhixi() {
      this.dialogControl = false
    },
    tanchu() {
      if (this.ellipsisShow === true) {
        this.dialogControl = true
      }
    },
    indexnotice() {
      getAction('/vtp/toaEnterParkApply/indexnotice').then((res) => {
        if (res.data.success) {
          if (res.data.message.length > 14) {
            this.ellipsisShow = true
            this.gonggao = res.data.message.slice(0, 14)
          } else {
            this.gonggao = res.data.message
          }
          this.gonggaocontent = res.data.message
        }
      })
    },
    jumpEdit() {
      this.$router.push({
        name: 'AdmissionNotice',
        params: {
        }
      })
    },
    jumpEdit1() {
      this.$router.push({
        name: 'edit1',
        params: {
        }
      })
    },
    jumpCancleVisit() {
      this.$router.push({
        path: 'history',
        query: {
          cancleable: 0
        }
      })
    },
    jumpApplicationRecord() {
      // window.location.href = "/history"
      this.$router.push({
        name: 'history',
        params: {
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.enterParkApplyrightcontent {
  color: white;
  font-size: 14px;
  padding-top: 20px;
  padding-left: 20px;
}
.enterParkApplyrightcontentTwo {
  color: white;
  font-size: 9px;
  padding-top: 4px;
  padding-left: 20px;
}
.enterParkApplyleftcontentDiv1 {
  color: white;
  font-size: 18px;
  font-weight: bold;
  padding-top: 40px;
  padding-left: 20px;
}
.enterParkApplyleftcontentDiv2 {
  color: white;
  font-size: 10px;
  padding-top: 8px;
  padding-left: 20px;
}
.bannercontainner {
  padding: 15px;
}
.gonggao {
  flex: 1;
  background-color: rgb(252, 104, 72);
  border-radius: 15px;
  height: 35px;
  line-height: 35px;
}
.banner {
  background-image: url('../assets/banner.jpg');
  background-size: 100% 100%;
}
.greeBack {
  background-color: green;
}
.gonggaocontainer {
  padding: 5px;
}
.gonggaocontent {
  flex: 4;
  height: 35px;
  text-align: left;
  line-height: 35px;
  text-indent: 15px;
}
.line {
  margin-top: 5px;
  background-color: rgb(246, 246, 246);
  height: 2px;
}
.linecontainer {
  padding-left: 10px;
  padding-right: 10px;
}
.enterParkApplyleftcontent {
  background-image: url('../assets/enterParkApply.jpg');
  background-size: 100% 100%;
  border-radius: 15px;
  text-align: left;
}
.allfunction {
  padding-top: 20px;
}
.enterParkApplyrightcontent1 {
  background-image: url('../assets/applyHistory.jpg');
  background-size: 100% 100%;
  margin-top: 10px;
  border-radius: 15px;
  text-align: left;
}
.enterParkApplyrightcontent2 {
  background-image: url('../assets/cancelApply.jpg');
  background-size: 100% 100%;
  margin-top: 10px;
  border-radius: 15px;
  text-align: left;
}
.enterParkApplycontainer {
  padding: 10px;
}
.enterParkApplyrightcontainer {
  padding-left: 0px;
  padding-right: 10px;
  padding-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue